import type { HTMLAttributes, ReactNode } from 'react'
import { cx } from './cx'

export interface CardProps extends Omit<HTMLAttributes<HTMLElement>, 'title'> {
  title?: ReactNode
  description?: ReactNode
  actions?: ReactNode
  padded?: boolean
}

// Cards sit on a 1px border; shadows are reserved for floating layers (menus, dialogs)
export function Card({ title, description, actions, padded = true, className, children, ...rest }: CardProps) {
  return (
    <section className={cx('bg-surface border border-line rounded-xl', padded && 'p-5', className)} {...rest}>
      {(title || actions) && (
        <div className={cx('flex flex-wrap items-start justify-between gap-3', (children !== undefined) && 'mb-4')}>
          <div className="flex flex-col gap-0.5">
            {title && <h2 className="m-0 font-heading text-base font-semibold text-ink">{title}</h2>}
            {description && <p className="m-0 text-[13px] text-ink-secondary">{description}</p>}
          </div>
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
      )}
      {children}
    </section>
  )
}
